// Aviso en pantalla cuando llegan jornadas nuevas (o una programada se
// abre) en cualquier territorio. Se muestra encima de todo, incluso sobre
// la ventana de elegir territorio, con un botón para entrar directo.
import { useEffect, useState } from "react";
import { fmtFecha } from "./jornadasBac";

export default function AvisoJornadasNuevas({ onIr }) {
  const [avisos, setAvisos] = useState([]); // [{ tipo, j }]

  useEffect(() => {
    const f = (ev) => {
      const { nuevas = [], iniciadas = [] } = ev.detail || {};
      const llegan = [
        ...nuevas.map((j) => ({ tipo: "nueva", j })),
        ...iniciadas.map((j) => ({ tipo: "iniciada", j })),
      ];
      setAvisos((prev) => {
        const vistos = new Set(prev.map((a) => `${a.tipo}|${a.j.codigo}`));
        return [...llegan.filter((a) => !vistos.has(`${a.tipo}|${a.j.codigo}`)), ...prev].slice(0, 5);
      });
      try { navigator.vibrate?.(200); } catch { /* sin vibración */ }
    };
    window.addEventListener("bac-jornadas-novedades", f);
    return () => window.removeEventListener("bac-jornadas-novedades", f);
  }, []);

  if (!avisos.length) return null;
  const quitar = (a) => setAvisos((p) => p.filter((x) => x !== a));

  return (
    <div style={{ position: "fixed", top: 8, left: 8, right: 8, zIndex: 2000, display: "flex", flexDirection: "column", gap: 6, pointerEvents: "none" }}>
      {avisos.map((a) => (
        <div key={`${a.tipo}|${a.j.codigo}`} role="status"
          style={{ pointerEvents: "auto", background: "#16342a", color: "#fff", borderRadius: 10, padding: "10px 12px", boxShadow: "0 4px 14px rgba(0,0,0,.25)", display: "flex", gap: 10, alignItems: "center", maxWidth: 560, margin: "0 auto", width: "100%" }}>
          <div style={{ flex: 1, minWidth: 0, fontSize: 14, lineHeight: 1.3 }}>
            <strong>{a.tipo === "nueva" ? (a.j.estado === "programada" ? "🗓️ Nueva jornada programada" : "🟢 Nueva jornada abierta") : "🟢 Jornada iniciada"}</strong>
            <div>{a.j.comunidad} · {a.j.territorio}</div>
            <small style={{ opacity: 0.85 }}>{fmtFecha(a.j.fecha_inicio)}{a.j.lider_nombre ? ` · Líder: ${a.j.lider_nombre}` : ""}</small>
          </div>
          <button type="button" className="btn btn-light btn-sm" onClick={() => { onIr(a.j); quitar(a); }}>Ir</button>
          <button type="button" aria-label="Cerrar aviso" className="btn btn-sm" style={{ color: "#fff" }} onClick={() => quitar(a)}>✕</button>
        </div>
      ))}
    </div>
  );
}
